import { useTranslation } from 'react-i18next';
import { DownloadSimpleIcon } from '@phosphor-icons/react';
import type { LegalDocumentVersion } from '@monorepo/shared';
import { useDownloadLegalVersion } from '../../services/legalDocuments.service';

interface LegalDocumentVersionsProps {
  versions: LegalDocumentVersion[];
}

export const LegalDocumentVersions = ({ versions }: LegalDocumentVersionsProps) => {
  const { t } = useTranslation();
  const { mutate: downloadVersion, isPending } = useDownloadLegalVersion();

  const currentVersion = versions.find((version) => version.isCurrent);
  const previousVersions = versions.filter((version) => !version.isCurrent);

  return (
    <div className="mb-8 rounded-lg border border-gray-200 bg-gray-50 p-4">
      {currentVersion && (
        <p className="text-sm font-medium text-text">
          {t('legal.versions.current', { date: currentVersion.date })}
        </p>
      )}

      <div className="mt-3">
        <p className="mb-2 text-xs font-semibold uppercase text-gray-500">
          {t('legal.versions.previous_title')}
        </p>

        {previousVersions.length === 0 ? (
          <p className="text-sm text-gray-500">{t('legal.versions.empty')}</p>
        ) : (
          <ul className="space-y-2">
            {previousVersions.map((version) => (
              <li key={version.fileName} className="flex items-center justify-between gap-3">
                <span className="text-sm text-text">
                  {t('legal.versions.item', { date: version.date })}
                </span>
                <button
                  type="button"
                  onClick={() => downloadVersion(version.fileName)}
                  disabled={isPending}
                  className="inline-flex items-center gap-2 text-sm font-medium text-primary hover:underline disabled:opacity-60"
                >
                  <DownloadSimpleIcon size={16} weight="bold" />
                  {t('common.download_pdf')}
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};
